export default __webpack_public_path__ + "static/嘉宾头像_张雷-7883fcbabf793e53ada027b22f57d8c6.png";